import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const DoughnutGraph = ({ series, className }) => {
	const formattedData = {
		labels: series.map(({ label }) => label),
		datasets: [
			{
				data: series.map(({ value }) => value),
				backgroundColor: series.map(({ colour }) => colour)
			}
		]
	};

	// option documentation:
	// https://www.chartjs.org/docs/latest/charts/doughnut.html#config-options
	let options = {
		responsive: true,
		legend: {
			display: false
		},
		cutoutPercentage: 60
	};

	return <Doughnut className={className} data={formattedData} options={options} />;
};

export default DoughnutGraph;
